<template>
  <form-sections
    :loading="loading"
    :error="error"
    :schema="schema"

    class="proposals-read-used-form"

    @submit="submit"
    @error="failure"
    @change="change"
  >
    <template v-slot:submit>
      Salvar e continuar
    </template>
  </form-sections>
</template>

<script>
  import { mapState } from 'vuex';

  import BANKS from '@sdk/helpers/domains/banks';
  import STATES from '@sdk/helpers/domains/states';

  import optionsHelper from '@cordel/helpers/form/select/options';

  import form from '@cordel/helpers/form/mixin';

  import FormSections from '@cordel/components/Form/Sections.vue';

  import payloadGenerator from './Used/payload';
  import schemaGenerator from './Used/schema';

  import {
    // KM,
    // PLATE,
    // RENAVAM,
    // CHASSIS,
    COLOR,
    LICENSING_CITY,
    LICENSING_UF,
  } from './Used/fields';

  export default {
    name: 'ProposalReadUsed',
    components: {
      FormSections,
    },
    mixins: [
      form,
    ],
    props: {
      proposal: {
        type: Object,
        default() {
          return {};
        },
      },
      customer: {
        type: Object,
        default() {
          return {};
        },
      },
      attempt: {
        type: Object,
        default() {
          return {};
        },
      },
      visibleFields: {
        type: Array,
        default() {
          return [];
        },
      },
    },
    data() {
      return {
        schema: schemaGenerator(),
        payload: payloadGenerator(),
      };
    },
    computed: {
      ...mapState([
        'proposals',
        'domainsWeb',
      ]),

      loading() {
        return this.proposals.update.loading;
      },
      error() {
        return this.proposals.update.error;
      },
    },
    watch: {
      steps() {
        this.visibility();
      },
    },
    mounted() {
      this.getColors();

      this.clear();
      this.visibility();
      this.fill();

      this.customize();
    },
    methods: {
      getColors() {
        this.updateLoading(COLOR, true);

        return this.$store
          .dispatch('domainsWeb/list', {
            types: 'vehicle_color',
          })
          .then(this.gotColors);
      },
      gotColors() {
        this.updateLoading(COLOR, false);

        this.updateOptions(COLOR, optionsHelper(this.domainsWeb.list.items.vehicle_color, {
          label: 'name',
          value: 'identifier',
        }));
      },

      visibility() {
        Object.keys(this.fields)
          .forEach(id => this.updateVisible(id, this.visibleFields.includes(id), { clear: false }));
      },

      clear() {
        this.$store.dispatch('proposals/clear', { action: 'update' });
      },
      fill() {
        this.setJSON(this.payload, this.proposal);
      },

      customize() {
        if (this.visibleFields.includes(LICENSING_UF)) {
          this.updateOptions(LICENSING_UF, STATES);

          const city = this.visibleFields.includes(LICENSING_CITY)
                       || this.fields[LICENSING_CITY].visible;
          const validations = [{ type: 'blank' }];
          const ferrari = this.proposal.zero_km && [
            BANKS.BRADESCO.code,
          ].includes(this.attempt.bank.febraban_code);

          if (ferrari) {
            const validation = state => state !== this.customer.address.state.abbreviation;
            const message = 'o estado de licenciamento precisa ser igual ao do endereço do cliente';

            validations.push({
              type: 'fn',
              fn: validation,
              message,
            });

            if (validation(this.proposal.licensing_uf)) {
              this.updateErrors(LICENSING_UF, message);
            }
          }

          this.updateSize(LICENSING_UF, city ? 6 : 12);
          this.updateValidations(LICENSING_UF, validations);
          this.updateDisabled(LICENSING_UF, !ferrari);
        }
      },

      change(field, value) {
        this.$emit('change', field, value);
      },

      submit() {
        this.$store
          .dispatch('proposals/update', {
            id: this.proposal.id,
            proposal: {
              ...this.getJSON(this.payload),
            },
          })
          .then(this.success)
          .catch(this.failure);
      },
      success() {
        this.$emit('success');
      },
      failure(e) {
        this.$emit('failure', e);
      },
    },
  };
</script>

<style lang="scss" scoped>
  @import '@cordel/assets/stylesheets/mixins/reset.scss';
  @import '@cordel/assets/stylesheets/variables/breakpoints.scss';
</style>
